export default __webpack_public_path__ + "static/media/intro-connection-light.5690d473.jpg";